import React from "react";

// Minimal stub: the original DeskingPage was removed from the repo but
// DeskingModal still imports it. This placeholder lets the bundle build for
// the reskin preview; the desking modal is not exercised on the pricing view.
export const DeskingPage = () => {
    return <div className="DeskingPage" />;
};
